import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export interface ButtonLayout {
    readonly selected: boolean;
}

export const LayoutButton = styled(Button)<ButtonLayout>`
    color: ${(props) => (props.selected ? 'var(--minor-accent__enabled__front__default);' : 'inherit')};
    min-width: 48px;
`;

export const ItemsHeaderWrapper = styled.header`
    position: relative;

    display: grid;
    grid-template-columns: 1fr auto 1fr;
    margin-top: 0.5rem;
    margin-bottom: 2rem;

    > * {
        align-self: center;
    }

    > :nth-of-type(3) {
        margin-left: auto;
    }

    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr 1fr;

        .a-page-indicator {
            display: none;
        }
        
        .grid-view, .list-view, .table-view {
            display: none;
        }
    }
`;
